export default __webpack_public_path__ + "static/media/4745@2x.93e14e62.png";